import React, {Component} from 'react';
import Price from "./Price";

let formatter = new Intl.NumberFormat(Price.locale(), {
    style: 'decimal',
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
});

class Change extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        let change = formatter.format(this.props.change);

        let changeStyle = 'neutral';
        let changeNotation = '';

        if (change > 0) {
            changeStyle = 'positive';
            changeNotation = '+';
        } else if (change < 0) {
            changeStyle = 'negative';
        }

        return (
            <span title={this.props.title || ''} className={'change ' + changeStyle}>
                {changeNotation}{ change } %
            </span>
        );
    }
}

export default Change;



// WEBPACK FOOTER //
// ./src/Change.js